// extracted by mini-css-extract-plugin
export default {"fullSizeDisco":"img-loading_fullSizeDisco__qiE+5"};